import {DeserializedElementRule} from "../../slate/Transformation";
import ComponentRule from "../../slate/booq/ComponentRule";
import React, {Fragment, useState} from "react";
import {set} from "../../../../../utils/dotutils";
import isEqual from "lodash-es/isEqual";
import Portal from "../../../../layout/Portal";
import Modal from "../../../../layout/Modal";
import Select from "../../../Select";
import {optionsTemplate} from "../../../../../utils/formatters";
import Button from "../../../Button";
import {ReactEditor} from "slate-react";
import {Transforms} from "slate";

export class PollNode extends React.Component<any, any> {

    constructor(props){
        super(props);
        this.state = {
            editing: false,
            toolbarPos: 'top',
            values: JSON.parse(JSON.stringify(props.element.props)),
            editvalues: JSON.parse(JSON.stringify(props.element.props))
        };
    }

    setData = (data) => {
        const path = ReactEditor.findPath(this.props.editor, this.props.element);
        Transforms.setNodes(this.props.editor, {props: {...data}}, {
            at: path,
        });
        this.setState({values: data, editvalues: data}, () => this.imgNode.focus());
    }

    setSelected = (e) => {
        e && e.preventDefault();
        const toolbarPos = this.node.offsetTop - this.node.closest(".rt-editor-input").scrollTop > 100 ? 'top' : 'bottom';
        this.setState({toolbarPos});
    }

    clearSelected = (e) => {
        e && e.preventDefault();
    }

    openEditor = (e) => {
        e && e.preventDefault();
        this.setState({editing: true});
    }

    onModalChange = (field, value) => {
        const editvalues = JSON.parse(JSON.stringify({...this.state.editvalues}));
        set(editvalues, field, value);
        this.setState({editvalues});
    }

    render() {

        const data = this.state.values || {};
        const editdata = this.state.editvalues || {};

        const actionButtons = [
            {
                text: "Ok",
                props: {color: "primary", className: "pull-right", disabled: isEqual(this.state.values, this.state.editvalues)},
                onClick: async () => {
                    this.setData(this.state.editvalues);
                    this.setState({editing: false});
                }
            }, {
                text: "Mégse",
                props: {color: "default"},
                className: "pull-right",
                onClose: true,
                onClick: async () => {
                    this.setState({editing:false, editvalues: JSON.parse(JSON.stringify(this.state.values))});
                }
            }
        ];

        return (
            <Fragment>
                <Portal>
                    <Modal
                        state={this.state.editing}
                        size="medium"
                        header={"Szerkesztése"}
                        buttons={actionButtons}
                    >
                        <div className="row form-row">
                            <div className="col-md-12">
                                <Select
                                    name="id"
                                    objectValue={false}
                                    component="Poll"
                                    storeType="remote"
                                    optionsTemplate={optionsTemplate('Poll')}
                                    saveChanges={this.onModalChange}
                                    value={editdata.id}
                                    labelKey="title"
                                    label="Szavazás"
                                />
                            </div>
                        </div>
                    </Modal>
                </Portal>
                <div
                    ref={(node)=>this.node = node}
                    contentEditable={false}
                    className="poll"
                    tabIndex={-1}
                    onMouseDown={this.setSelected}
                    onFocus={this.setSelected}
                    onBlur={this.clearSelected}
                    onKeyDown={this.onKeyDown}
                >
                    {this.props.children}
                    <div className={"poll-tools poll-tools-" + this.state.toolbarPos + " btn-toolbar"}>
                        <Button
                            onClick={this.openEditor}
                            icon="edit"
                            tooltip="Szerkesztés"
                            color="default"
                        />
                        <Button
                            onClick={this.props.remove}
                            icon="delete"
                            tooltip="Törlés"
                            color="default"
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

const toolbarButton = (props) => {
    const [opened, setOpened] = useState(false);
    const [poll, setPoll] = useState(null);
    return <Fragment>
        <Portal>
            <Modal
                state={opened}
                header="Szavazás beszúrása"
                size="medium"
                buttons={[
                    {
                        text: "Ok",
                        props: {color: "primary", className: "pull-right", disabled: !poll},
                        onClick: () => {
                            props.insert({
                                type: 'component',
                                props: {
                                    props: {
                                        type: 'Poll',
                                        id: poll,
                                    }
                                }
                            });
                            setPoll(null);
                            setOpened(false);
                        }
                    }, {
                        text: "Mégse",
                        props: {color: "default"},
                        className: "pull-right",
                        onClose: true,
                        onClick: async () => {
                            setOpened(false);
                        }
                    }
                ]}
            >
                <div className="form-group">
                    <Select
                        name="id"
                        component="Poll"
                        optionsTemplate={optionsTemplate('Poll')}
                        value={poll}
                        labelKey="title"
                        label="Szavazás"
                        storeType="remote"
                        objectValue={false}
                        saveChanges={(field, value) => setPoll(value)}
                    />
                </div>
            </Modal>
        </Portal>
        <Button
            onClick={() => {
                setOpened(true);
                return false;
            }}
            icon={{lib: "fas", name: "poll-h"}}
            color="default"
            tooltip="Szavazás beszúrása"
            disabled={props.disabled}
        />
    </Fragment>
}

export default PollNode;

export const Rules: {[key: string]: DeserializedElementRule<HTMLElement>} = {
    "Poll": ComponentRule({
        isVoid: () => true,
        type: 'Poll',
        render: PollNode,
        toolbarButton,
    })
}